import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, signal } from "@angular/core";
import { ICustomerOverview } from "@rfm/shared-interfaces";
import { CardModule } from "primeng/card";

@Component({
  selector: "app-account-information",
  standalone: true,
  imports: [CommonModule, CardModule],
  templateUrl: "./account-information.component.html",
  styleUrls: ["./account-information.component.scss"],
})
export class AccountInformationComponent implements OnInit {
  @Input()
  customer_overview = signal<ICustomerOverview | undefined>(undefined);

  constructor() {}

  ngOnInit() {}

  getCustomerAddress() {
    return `${this.customer_overview()?.mailing_address?.line1}, ${
      this.customer_overview()?.mailing_address?.town
    }, ${this.customer_overview()?.mailing_address?.postal_code}`;
  }
}
